import React from 'react';
import GSessionViewModal from './GSessionViewModal'
import { sessionDetails } from '../../../models/GSessions';
import {EventFullInfo} from '../../../models/event';
import { toggleUserSessionStatus } from '../../../functions/Sessions';
import GSessionEditModal from './GSessionEditModal';
import GSessionCreateModal from './GSessionCreateModal';
import { isUserAdmin } from '../../../models/user/userAuthorization';
import moment from 'moment';
import { EventSessionCreationPermissionStatus, getUserSessionCreationPermissionsForEvent } from '../../../functions/Events';


interface GSessionModalProps {
    modalState: boolean,
    requestClose: ()=>void,
    refreshSessions: ()=>void,
    focusSession?: sessionDetails,
    event: EventFullInfo,
    user_id?: number,
    token?: string,
    user_name?: string,
    playerNames?: string[]
}

const GSessionModal = (props: GSessionModalProps) => {
    

    const [modalMode, setModalMode] = React.useState<string>('Create');
    const [canEditFocusedSession, setCanEditFocusedSession] = React.useState<boolean>(false);
    const [canCreateSession, setCanCreateSession] = React.useState<boolean>(false);


    React.useEffect( () => {
        const queryFcn = async () => {userCanCreateSession().then((res) => 
        {
            if (res && (!props.event.session_lock || moment(props.event.session_lock) > moment(new Date()))) 
            {
                setCanCreateSession(true);
            }
            else
            {
                setCanCreateSession(false);
            }
        })};

        queryFcn();
    },[modalMode, props.modalState])


    React.useEffect(() => {

        if (props.focusSession === undefined) 
        {
            setModalMode('Create');
        }
        else
        {
            setModalMode('View');
        }
        userCanEditSession().then((res) => 
        {
            if(!props.event.session_lock || moment(props.event.session_lock) > moment(new Date()))
            {
                setCanEditFocusedSession(res);
            }
            else
            {
                setCanEditFocusedSession(false);
            }
            
        })

    }, [props.focusSession])



    const componentRequestsEdit = () => 
    {
        if(canEditFocusedSession)
        {
            props.user_id && props.user_name && setModalMode('Edit');
        }
    }

    const componentRequestsView = () => 
    {
        props.focusSession && setModalMode('View');
    }



    const componentRequestsClose = () => 
    {
        props.requestClose()
    }



    const sessionUpdateRequest = (sesh: sessionDetails) => {

        const object =
        {
            start_time: sesh.start,
            end_time: sesh.end,
            name: sesh.name,
            bgg_title_link: sesh.bgg_title_link,
            info: sesh.info,
            room: '',
            table: sesh.table,
            slots: sesh.slots,
            owner_player: sesh.owner_player,
            owner: props.user_id,
            event_id: props.event.id,
            id: props.focusSession?.id
        }

        const requestOptions =
        {
            body: JSON.stringify(object),
            method: 'POST',
            headers:
            {
                'Content-Type': `application/json`,
                "Access-Control-Allow-Origin": "*",
                'Authorization': `Bearer ${props.token}`
            }
        }

        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/gsessions/editgsession', requestOptions)
            .then(res => res.json())
            .then((result) =>
            {
                if (result.status === 'success')
                {
                    //Return to the View screen and refresh
                    props.refreshSessions();
                    setModalMode('View');
                    return true;
                }
                else
                {
                    console.log(result);
                    console.log(result.reason);
                    //TODO: Error Message
                    window.location.reload();
                    return false;
                }
            })
    }

    const sessionCreateRequest = (sesh: sessionDetails) => {
        
        const start_time_local = moment.tz(sesh.start as Date,'America/New_York');
        const end_time_local = moment.tz(sesh.end as Date,'America/New_York');


        const object =
        {
            start_time: start_time_local.utc(),
            end_time: end_time_local.utc(),
            name: sesh.name,
            bgg_title_link: sesh.bgg_title_link,
            info: sesh.info,
            room: "",
            table: sesh.table,
            slots: sesh.slots,
            owner_player: sesh.owner_player,
            owner: props.user_id,
            event_id: props.event.id
        }
        
        
        const requestOptions =
        {
            body: JSON.stringify(object),
            method: 'POST',
            headers:
            {
                'Content-Type': `application/json`,
                "Access-Control-Allow-Origin": "*",
                'Authorization': `Bearer ${props.token}`
            }
        }
        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/gsessions/creategsession', requestOptions)
            .then(res => res.json())
            .then((result) =>
            {
                if (result.status === 'success')
                {
                    props.refreshSessions();
                    props.requestClose();
                    return true;
                }
                else
                {
                    console.log(result);
                    console.log(result.reason);
                    //TODO: Error Message
                    window.location.reload();
                    return false;
                }
            })
    }


    const sessionDeleteRequest = () => {

        const requestOptions =
        {
            method: 'DELETE',
            headers:
            {
                'Authorization': `Bearer ${props.token}`
            }
        }

        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/gsessions/deletegsession/' + props.focusSession?.id, requestOptions).then(res => res.json())
            .then((result) => {
                if(result.status === 'success')
                {
                    props.refreshSessions();
                    props.requestClose()

                }
                else
                {
                    console.log(result);
                    props.refreshSessions();
                    props.requestClose();
                }
            })
    }

    const userCanEditSession = async () => {

        if (props.user_name && props.user_name === props.focusSession?.owner) 
        {
            return true;
        }
        else if (props.token && props.user_id && await isUserAdmin(props.token, props.user_id))
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    const userCanCreateSession = async () => {

        if(props.user_id)
        {
            return getUserSessionCreationPermissionsForEvent(props.user_id, props.event.id).then((res) =>
            {
                if(res === EventSessionCreationPermissionStatus.canCreateSessions)
                {
                    return true;
                }
                return false;
            })
        }
        else
        {
            return Promise.resolve(false);
        }
    }


    const userRelenquishSlot = () => {
        props.focusSession && toggleUserSessionStatus({user: props.user_id, authToken: props.token}, props.focusSession.id, false).then((res) => 
            {
              res && props.refreshSessions();
            })
    }

    const userSignUp = () => {
        props.focusSession && toggleUserSessionStatus({user: props.user_id, authToken: props.token}, props.focusSession.id, true).then((res) => 
            {
            res && props.refreshSessions();
            })
    }

    return(
        <dialog className="modal" open={props.modalState}>
            <div className="modalInner">

                {(modalMode === 'Create') && props.user_name && canCreateSession && <GSessionCreateModal
                    requestClose={componentRequestsClose}
                    user_name={props.user_name}
                    event = {props.event}
                    onSessionCreate = {sessionCreateRequest}
                />}

                {(modalMode === 'Create') && (!props.user_name || !canCreateSession) && <div>
                    <b>You are not authorized to create Events!</b>
                    <button className="buttonPrimary" onClick={componentRequestsClose}>Back to Calendar</button>
                </div>}
                            
                {(modalMode === 'View') && props.focusSession && props.playerNames && <GSessionViewModal
                    requestClose={componentRequestsClose}
                    requestEdit={componentRequestsEdit}
                    session={props.focusSession}
                    event = {props.event}
                    user_id={props.user_id}
                    user_name={props.user_name}
                    playerNames={props.playerNames}
                    onRelinquishSlot={userRelenquishSlot}
                    onSignUp={userSignUp}
                    canUserEdit={canEditFocusedSession}
                />}

                {props.user_id && props.user_name && (modalMode === 'Edit') && props.focusSession && props.playerNames && <GSessionEditModal
                    requestClose={componentRequestsClose}
                    requestView={componentRequestsView}
                    session={props.focusSession}
                    event = {props.event}
                    user_id={props.user_id}
                    user_name={props.user_name}
                    playerNames={props.playerNames}
                    onSessionUpdate={sessionUpdateRequest}
                    onSessionDelete={sessionDeleteRequest}
                />}
            
            </div>
    
        </dialog>
    )

}

export default GSessionModal;